import { setInvestigationTypes } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import { MultiselectFilter } from './MultiselectFilter';
import { useMemo } from 'react';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { AssetInvestigationType } from '@customer/store/apis/investigationsApi';

// Create a list of investigation types that can be used in filters.
const InvestigationTypeFilterValues = Object.values(AssetInvestigationType).filter(
  it => it !== AssetInvestigationType.Unknown,
);

const useInvestigationTypesOptions = (): DropdownItemProps<AssetInvestigationType>[] => {
  const { t } = useTranslation();

  return useMemo<DropdownItemProps<AssetInvestigationType>[]>(() => {
    return InvestigationTypeFilterValues.map(it => {
      return { key: it, value: it, stringValue: it, label: t(`Enum.InvestigationType.${it}`) };
    }).sort((a, b) => a.label.localeCompare(b.label));
  }, [t]);
};

export const InvestigationTypesFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();

  return (
    <MultiselectFilter<AssetInvestigationType>
      filterName="investigationTypes"
      label={label ?? t('InvestigationType')}
      action={setInvestigationTypes}
      elementRef={elementRef}
      useItemsHook={useInvestigationTypesOptions}
    />
  );
};

export default InvestigationTypesFilter;
